import { useEffect, useState } from "react";
import { getAppListings } from "../../../services/api";
import { AppListing } from "../../../types/appListing";

const useApps = () => {
  const [apps, setApps] = useState<AppListing[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      const { status, data } = await getAppListings();
      if (status === 200) setApps(data);
      setLoading(false);
    };
    fetch();
  }, []);

  return { apps, loading };
};

export default useApps;
